import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, Facet, OccEndpointsService, OccProductSearchAdapter, ProductSearchPage, } from '@spartacus/core';
import { FacetService } from '@spartacus/storefront';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  countDetails$ = new BehaviorSubject(null);
  selectedTabIndex = new BehaviorSubject(0);

  seperateDocDetails$ = new BehaviorSubject<ProductSearchPage | null>(null);
  seperateSoftDetails$ = new BehaviorSubject(null);
  docFormDetails: any;
  isDocpaginationClickEvent: boolean = false;
  softwareFormDetails: any;

  SteeringProdDetails$ = new BehaviorSubject(null);
  FormulaProdDetails$ = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService,
    public searchService: OccProductSearchAdapter,
    public facetService: FacetService,
    private converterService: ConverterService
  ) { }

  /*  getCrossRefDetails(pageSize: any, query: any, currentPage: any, sort?: any) {
     return this.http
       .get(
         this.occService.buildUrl('kbsearch/xref?fields=FULL', {
           queryParams: {
             pageSize,
             query,
             currentPage,
             sort,
           },
         })
       )
       .pipe(
         map((res: any) => {
           console.log(res);
           if (res.facets) {
             res = { ...res, facets: this.getFacets(res.facets) };
           }
           if (res.products) {
             res = {
               ...res,
               products: res.products.map((product: any) => this.converterService.convert(product, KB_PRODUCT_URL_NORMALIZER)),
             };
           }
           // console.log("res",res);
           return res;
         }),
         catchError((error) => {
           return of(null);
         })
       );
   }

   getDocumentDetails(pageSize: any, query: any, currentPage: any, sort?: any) {
     return this.http
       .get(
         this.occService.buildUrl('kbsearch/document?fields=FULL', {
           queryParams: {
             pageSize,
             query,
             currentPage,
             sort,
           },
         })
       )
       .pipe(
         map((res: any) => {
           if (res.facets) {
             res = { ...res, facets: this.getFacets(res.facets) };
           }
           if (res.products) {
             res = {
               ...res,
               products: res.products.map((product: any) => this.converterService.convert(product, KB_PRODUCT_URL_NORMALIZER)),
             };
           }
           return res;
         }),
         catchError((error) => {
           return of(null);
         })
       );
   }

   getSoftwareDetails(pageSize: any, query: any, currentPage: any, sort?: any) {
     return this.http
       .get(

         this.occService.buildUrl('kbsearch/software?fields=FULL', {
           queryParams: {
             pageSize,
             query,
             currentPage,
             sort,
           },
         })
       )
       .pipe(
         map((res: any) => {
           console.log(res);
           if (res.facets) {
             res = { ...res, facets: this.getFacets(res.facets) };
           }

           return res;
         }),
         catchError((error) => {
           return of(null);
         })
       );
   }




  getCustomDocDetails(pageSize: any, query: any, currentPage: any, sort?: any) {
    return this.http.get(

      this.occService.buildUrl('documentLibrary/kbRaildocument?fields=FULL', {
        queryParams: {
          pageSize,
          query,
          currentPage,
          sort,
        },
      })
    );
  }*/
  DecodeQuery(query: string) {
    // Decoding the query by replacing special characters with their respective characters
    const res = this.facetService.getLinkParams(query);
    return res!['query'];
  }
  getCustomDocumentDetails(searchDetails: { searchKey?: string; productCategory: any; docType: any; docProductGroup: any; }, pageSize: any, currentPage: any, sort?: string) {
    if (!this.isDocpaginationClickEvent) {
      this.docFormDetails = searchDetails;
    }
    console.debug(searchDetails);
    return this.http
      .get(
        this.occService.buildUrl('kbsdocumentLibrary/kbRaildocument', {
          queryParams: {
            pageSize,
            q: this.docFormDetails?.searchKey,
            docType: searchDetails?.docType,
            docCategory: searchDetails?.productCategory,
            docProductGroup: searchDetails?.docProductGroup,
            page: currentPage,
            sort
          },
        })
      )
      .pipe(
        map((res: any) => {
          console.log(res);
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          return res;
        })
      );
  }
  getCustomDocQuery(query: any) {
    this.docFormDetails.searchKey = this.DecodeQuery(query);
    return this.docFormDetails;
  }
  /* getCustomSoftwareDetails(searchDetails: { searchKey: any; packageType: any; softwareType: any; softwareGroup: any; language: any; }, pageSize: any, currentPage: any, sort?: any) {
    this.softwareFormDetails = searchDetails;
    return this.http
      .get(

        this.occService.buildUrl('softwareLibrary/kbsoftwares?fields=FULL', {
          queryParams: {
            pageSize,
            text: searchDetails?.searchKey,
            q: this.softwareFormDetails?.searchKey,
            packageType: searchDetails?.packageType,
            softwareType: searchDetails?.softwareType,
            softwareGroup: searchDetails?.softwareGroup,
            softwareLanguage: searchDetails?.language,
            page: currentPage,
            sort,
          },
        })
      )
      .pipe(
        map((res: any) => {
          console.log(res);
          if (res.facets) {
            res = { ...res, facets: this.getFacets(res.facets) };
          }
          return res;
        })
      );
  } */
  /* getCustomSoftwareQuery(query: any) {
    this.softwareFormDetails.searchKey = this.DecodeQuery(query);
    return this.softwareFormDetails;
  }

  checkStockAvailability(orderType: any, productCode: any, quantity: any) {
    return this.http.get(
      this.occService.buildUrl(
        `products/stockAvailability?orderType=${orderType}&productCode=${productCode}&quantity=${quantity}`
      )
    );
  } */
  getFacets(facets: Facet[]) {
    return facets.map((facetSource: Facet) => {
      const { topValues, ...facetTarget } = facetSource;
      facetTarget.topValueCount = topValues && topValues.length > 0 ? topValues.length : 5;
      return facetTarget;
    });
  }
}


declare module '@spartacus/core' {
  export interface ProductSearchPage {
    kbRailDocuments?: any;
    kbRailDocumentsCounts?: number;
  }
}
